import './DomainPill.css';

interface Props {
  name: string;
  color: string;
  count: number;
}

export function DomainPill({ name, color, count }: Props) {
  const rgba = toRgba(color);
  return (
    <div
      className="domain-pill"
      style={{
        background: withAlpha(rgba, 0.08),
        borderColor: withAlpha(rgba, 0.3),
        color: withAlpha(rgba, 0.95),
      }}
    >
      <span className="domain-pill__name">{name}</span>
      <span className="domain-pill__sep">·</span>
      <span className="domain-pill__count">{count}</span>
    </div>
  );
}

function toRgba(color: string): string {
  if (color.startsWith('rgba') || color.startsWith('rgb')) return color;
  if (!color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const bigint = parseInt(
    hex.length === 3
      ? hex.split('').map((c) => c + c).join('')
      : hex,
    16,
  );
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r},${g},${b},1)`;
}

function withAlpha(rgba: string, alpha: number): string {
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) return rgba;
  return `rgba(${match[1]},${match[2]},${match[3]},${alpha})`;
}
